import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage';

const CenterTopMenu = () => import('CJ/views/CenterTopMenu.vue');
const Login = () => import('CJ/views/Login/Login.vue');
const ChatAnonymity = () => import('CJ/views/ChatAnonymity/ChatAnonymity.vue');
const Timeout = () => import('CJ/views/ErrorHandle/Timeout.vue');
const Offline = () => import('CJ/views/ErrorHandle/Offline.vue');
const Home = () => import('CJ/views/Home/Home.vue');
const ErrorMsg = () => import('CJ/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('CJ/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('CJ/views/Register/Register.LinkFailure.vue');
const Bet = () => import('CJ/views/Bet/Bet.vue');
const MultiBet = () => import('CJ/views/MultiBet/MultiBet.vue');

const AccountInfo = () => import('CJ/views/AccountCenter/AccountInfo.vue');
const AwardDetail = () => import('CJ/views/AwardDetail/AwardDetail.vue');
const MyDailyPayAndContract = () => import('CJ/views/MyDailyPayAndContract/MyDailyPayAndContract.vue');
const AccountSecurity = () => import('CJ/views/AccountCenter/AccountSecurity.vue');
const LoginRecord = () => import('CJ/views/LoginRecord/LoginRecord.vue');
const DepositRequestCreate = () => import('CJ/views/DepositRequest/Create.vue');
const DepositQrcode = () => import('CJ/views/DepositRequest/DepositQrcode.vue');
const DepositPayInfo = () => import('CJ/views/DepositRequest/PayInfo.vue');
const CreatePlayer = () => import('CJ/views/Player/Player.Create.vue');
const Player = () => import('CJ/views/Player/Player.vue');
const BonusManagement = () => import('CJ/views/BonusManagement/BonusManagement.vue');
const HelperCenter = () => import('CJ/views/HelperCenter/HelperCenter.vue');
const WithdrawRequest = () => import('CJ/views/WithdrawRequest/WithdrawRequest.vue');
const RegisterLink = () => import('CJ/views/RegisterLink/RegisterLink.vue');
const BankCard = () => import('CJ/views/BankCard/BankCard.vue');
const CreateBankCard = () => import('CJ/views/BankCard/BankCard.Create.vue');
const CreateAliPay = () => import('CJ/views/BankCard/AliPay.Create.vue');
const CreateWeChat = () => import('CJ/views/BankCard/WeChat.Create.vue');
const CreateENCY = () => import('CJ/views/BankCard/ENCY.Create.vue');
const Register = () => import('CJ/views/Register/Register.vue');
const DepositAndWithdrawRecord = () => import('CJ/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const ExternalGameTransRecord = () => import('CJ/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const ExternalGameSubItem = () => import('CJ/views/ExternalGame/ExternalGameSubItem.vue');
const ExternalGameLobby = () => import('CJ/views/ExternalGame/ExternalGameLobby.vue');
const TrendChartStatistics = () => import('CJ/views/TrendChart/Statistics.vue');
const TrendChartOverview = () => import('CJ/views/TrendChart/Overview.vue');
const TransferPointRecord = () => import('CJ/views/TransferPointRecord/TransferPointRecord.vue');
const Transfer = () => import('CJ/views/TransferPoint/Transfer.vue');
const UserStatisticsReport = () => import('CJ/views/UserStatisticsReport/UserStatisticsReport.vue');
const BetRecord = () => import('CJ/views/BetRecord/BetRecord.Main.vue');
const DividendRecord = () => import('CJ/views/DividendRecord/DividendRecord.vue');
const ProportionalDividend = () => import('CJ/views/ProportionalDividend/ProportionalDividend.vue');
const ProfitReport = () => import('CJ/views/ProfitReport/ProfitReport.Main.vue');
const ScheduleRecord = () => import('CJ/views/ScheduleRecord/ScheduleRecord.Main.vue');
const CashFlowRecord = () => import('CJ/views/CashFlowRecord/CashFlowRecord.Main.vue');
const LotteryGameStatistics = () => import('CJ/views/LotteryGameStatistics/LotteryGameStatistics.Main.vue');
const DrawHistory = () => import('CJ/views/DrawHistory/DrawHistory.vue');
const CreateUSDTAddress = () => import('CJ/views/USDTAddress/USDTAddress.Create.vue');
const ElectronicPurseManualCreate = () => import('CJ/views/ElectronicPurse/ElectronicPurse.create.manual.vue');
const ElectronicPurseQRCodeCreate = () => import('CJ/views/ElectronicPurse/ElectronicPurse.create.qrcode.vue');
const IFrame = () => import('CJ/views/IFrame.vue');
const Activity = () => import('CJ/views/Activity/Activity.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', name: 'Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', name: 'Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', name: 'LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        {
            path: '/DepositPayInfo/:SerialNumber',
            name: 'DepositPayInfo',
            component: DepositPayInfo,
            meta: { ignoreAuth: true },
        },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        { path: '/', name: 'Home', component: Home },
        { path: '/Bet/:id', name: 'Bet', component: Bet },
        { path: '/MultiBet/:type', name: 'MultiBet', component: MultiBet },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
        { path: '/HelperCenter', component: HelperCenter },
        { path: '/ExternalGameSubItem/:gameType', component: ExternalGameSubItem },
        { path: '/ExternalGameLobby/:gameCategory', component: ExternalGameLobby },
        { path: '/Activity', name: 'Activity', component: Activity },
        {
            path: '/Center',
            component: CenterTopMenu,
            children: [
                { path: 'AccountInfo', component: AccountInfo },
                { path: 'AwardDetail', component: AwardDetail },
                { path: 'MyDailyPayAndContract', component: MyDailyPayAndContract },
                { path: 'BankCard', name: 'BankCard', component: BankCard },
                { path: 'CreateBankCard', name: 'CreateBankCard', component: CreateBankCard },
                { path: '/CreateAliPay/:CurrentBankType', name: 'CreateAliPay', component: CreateAliPay, props: true },
                { path: '/CreateWeChat/:CurrentBankType', name: 'CreateWeChat', component: CreateWeChat, props: true },
                { path: '/CreateECNY/:CurrentBankType', name: 'CreateENCY', component: CreateENCY, props: true },
                { path: 'AccountSecurity', component: AccountSecurity },
                { path: 'LoginRecord', component: LoginRecord },
                { path: 'DepositCreate', component: DepositRequestCreate },
                { path: 'CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: 'Player', component: Player, meta: { isAgentAllow: true } },
                { path: 'BonusManagement', component: BonusManagement, meta: { isAgentAllow: true } },
                { path: 'WithdrawRequest', component: WithdrawRequest },
                { path: 'RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: 'DepositAndWithdrawRecord', component: DepositAndWithdrawRecord },
                { path: 'TrendChartStatistics', component: TrendChartStatistics, meta: { isAgentAllow: true } },
                { path: 'TrendChartOverview', component: TrendChartOverview, meta: { isAgentAllow: true } },
                { path: 'TransferPointRecord', component: TransferPointRecord },
                { path: 'UserStatisticsReport', component: UserStatisticsReport, meta: { isAgentAllow: true } },
                { path: 'Transfer', name: 'Transfer', component: Transfer },
                { path: 'BetRecord', name: 'BetRecord', component: BetRecord },
                { path: 'DividendRecord', name: 'DividendRecord', component: DividendRecord },
                { path: 'ProportionalDividend',name:'ProportionalDividend', component: ProportionalDividend},
                { path: 'ProfitReport', component: ProfitReport },
                { path: 'ScheduleRecord', component: ScheduleRecord },
                { path: 'CashFlowRecord', component: CashFlowRecord },
                { path: 'LotteryGameStatistics', component: LotteryGameStatistics },
                { path: 'CreateUSDTAddress', name: 'CreateUSDTAddress', component: CreateUSDTAddress },
                { path: 'CreateElectronicPurseManual', name: 'ElectronicPurseManualCreate', component: ElectronicPurseManualCreate, props: true },
                { path: 'CreateElectronicPurseQRCode', name: 'ElectronicPurseQRCodeCreate', component: ElectronicPurseQRCodeCreate, props: true },
            ],
        },
        { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory },
        { path: '/IFrame', name: 'IFrame', component: IFrame },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == 'Login') {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some((record) => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some((record) => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        } else if (to.name === 'Home' && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/speedtest');
        } else {
            next('/Timeout'); // 認證已過期
        }
    }
});

export default router;
